import React from 'react';

import { CoachType } from '../../../graphql/types';
import { SplitFlags } from '../../../hooks/featureFlags';
import { useFeatureFlags } from '../../../hooks/useFeatureFlags';
import { EventLabels } from '../../../utils/trackingEvents';
import { NavigationItem, NavigationWrapper } from './Navigation';

interface Props {
  coachType: CoachType;
}

export const FitNavigation: React.FC<Props> = ({ coachType }: Props) => {
  const { flags } = useFeatureFlags();
  const serviceBookingEnabled = flags[SplitFlags.CH_SERVICE_BOOKING];

  return (
    <NavigationWrapper>
      <NavigationItem
        to="/app"
        testId="NavigationHomeLink-Fit"
        eventLabel={EventLabels.Home}
        show={coachType !== CoachType.CalendarOnly}
      >
        Home
      </NavigationItem>
      <NavigationItem
        to="/app/members"
        testId="NavigationMembersLink-Fit"
        eventLabel={EventLabels.Members}
        show={
          coachType !== CoachType.Dietitian &&
          coachType !== CoachType.CalendarOnly
        }
      >
        Members
      </NavigationItem>
      <NavigationItem
        to="/app/sessions"
        testId="NavigationSessionsLink-Fit"
        eventLabel={EventLabels.SessionsTab}
        show={coachType !== CoachType.CalendarOnly}
      >
        Sessions
      </NavigationItem>
      <NavigationItem
        to="/app/classes"
        testId="NavigationClassesLink-Fit"
        eventLabel={EventLabels.ClassesTab}
      >
        Classes
      </NavigationItem>
      <NavigationItem
        to="/app/services"
        testId="NavigationServicesLink-Fit"
        eventLabel={EventLabels.ServicesTab}
        show={serviceBookingEnabled && coachType === CoachType.Coach}
      >
        Services
      </NavigationItem>
      <NavigationItem
        to="/app/movement-library"
        testId="NavigationMovementLibraryLink-Fit"
        eventLabel={EventLabels.MovementLibraryTab}
      >
        Movement Library
      </NavigationItem>
      <NavigationItem
        to="/app/methodology"
        testId="NavigationMethodologyLink-Fit"
        eventLabel={EventLabels.Methodology}
      >
        Coach O - Methodology chatbot
      </NavigationItem>
    </NavigationWrapper>
  );
};
